import type { PublisherData } from '@/types/boot';

const ZENDESK_FIELD_IDS = {
  PLAYER_ID: 25438695019421,
  ORDER_ID: 25438747117213,
  PROJECT_ID: 25438782685085,
  COUNTRY: 25438841537437,
  PROJECT_NAME: 23783406389789,
  COMPANY: 25474794377117,
};

export const generateZendeskSupportURL = ({
  customerId,
  publisherId,
  publisherData,
  customerCountryCode,
  orderId,
}: {
  customerId?: string;
  publisherId?: string;
  publisherData?: PublisherData;
  customerCountryCode?: string;
  orderId?: string;
}) => {
  return `https://appchargeHelp.zendesk.com/hc/en-us/requests/new?tf_${
    ZENDESK_FIELD_IDS.PLAYER_ID
  }=${customerId || ''}&tf_${ZENDESK_FIELD_IDS.ORDER_ID}=${
    orderId || ''
  }&tf_${ZENDESK_FIELD_IDS.PROJECT_ID}=${publisherId || ''}&tf_${ZENDESK_FIELD_IDS.COMPANY}=${
    publisherData?.companyId || ''
  }&tf_25438841537437=${customerCountryCode || ''}&tf_${
    ZENDESK_FIELD_IDS.PROJECT_NAME
  }=${publisherData?.companyName || ''}`;
};
